import * as yup from 'yup'

export const schema = yup.object().shape({
  amount: yup.string().required(),
})

export default schema
